import { render, staticRenderFns } from "./OrthoDetails.vue?vue&type=template&id=6eeb3346&scoped=true"
import script from "./OrthoDetails.vue?vue&type=script&lang=js"
export * from "./OrthoDetails.vue?vue&type=script&lang=js"
import style0 from "./OrthoDetails.vue?vue&type=style&index=0&id=6eeb3346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeb3346",
  null
  
)

export default component.exports